import React from 'react';

import { SVGPropsType } from 'src/types';
const New = (props: SVGPropsType) => {
    const { fill = '#FFAF12', onClick, style, className } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="8"
            viewBox="0 0 19 8"
            fill="none"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M1.69 2.72L0.85 1.17H0.82V6.98H0V0H0.97L3.52 4.26L4.36 5.81H4.39V0H5.21V6.98H4.24L1.69 2.72ZM8.93 7.1C8.58 7.1 8.26 7.04 7.97 6.91C7.69 6.78 7.45 6.6 7.24 6.37C7.04 6.13 6.88 5.85 6.77 5.52C6.66 5.19 6.61 4.81 6.61 4.4C6.61 3.99 6.66 3.62 6.77 3.29C6.88 2.96 7.04 2.67 7.24 2.44C7.45 2.2 7.69 2.02 7.97 1.89C8.26 1.76 8.58 1.7 8.93 1.7C9.28 1.7 9.59 1.76 9.86 1.89C10.13 2.02 10.37 2.19 10.56 2.42C10.75 2.64 10.9 2.9 11 3.21C11.11 3.52 11.16 3.85 11.16 4.22V4.6H7.45V4.84C7.45 5.06 7.48 5.27 7.55 5.46C7.62 5.65 7.72 5.81 7.85 5.95C7.98 6.09 8.14 6.2 8.33 6.28C8.52 6.36 8.74 6.4 8.98 6.4C9.31 6.4 9.59 6.32 9.83 6.17C10.08 6.02 10.27 5.8 10.4 5.51L10.97 5.92C10.8 6.27 10.54 6.56 10.19 6.78C9.84 6.99 9.42 7.1 8.93 7.1ZM8.93 2.37C8.71 2.37 8.51 2.41 8.33 2.49C8.15 2.56 7.99 2.67 7.86 2.81C7.73 2.95 7.63 3.12 7.56 3.31C7.49 3.5 7.45 3.7 7.45 3.93V4H10.3V3.89C10.3 3.43 10.17 3.06 9.92 2.79C9.67 2.51 9.34 2.37 8.93 2.37ZM11.89 1.82H12.67L13.22 4.05L13.77 6.31H13.79L14.42 4.05L15.07 1.82H15.78L16.45 4.05L17.09 6.31H17.11L17.64 4.05L18.2 1.82H18.95L17.58 6.98H16.59L15.87 4.5L15.42 2.93H15.4L14.96 4.5L14.24 6.98H13.27L11.89 1.82Z"
                fill={fill}
            />
        </svg>
    );
};
export default New;
